import React, { ReactNode } from 'react'

interface IContent {
    // title: string;
    className?: string,
    // isShowTitle?: boolean,
    children?: ReactNode
}

const ContentContainer = ({
    // title,
    className = '',
    // isShowTitle = true, // Set default value to true
    children
}: IContent) => {
    return (
        <div className={`sm:p-10 sm:px-10 p-5 px-5 flex flex-col w-full min-w-0 ${className}`}>
            {/* {isShowTitle && <h1 className='text-2xl text-white font-semibold'> {title}</h1>} */}
            {children}
        </div>
    )
}

export default ContentContainer